import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { getDisplayInitials } from '../employee-gender';

@Component({
  selector: 'app-vms-profile-avatar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="vms-profile-avatar" [ngClass]="sizeClass" [attr.aria-label]="name || 'Profile avatar'">
      @if (hasPhoto) {
        <img [src]="photoUrl!" [alt]="name || 'Profile photo'" (error)="onImageError()" />
      } @else {
        <span class="vms-profile-avatar-initials">{{ initials }}</span>
      }
    </span>
  `,
  styles: [
    `
      .vms-profile-avatar {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        background: var(--surface-200);
      }

      .vms-profile-avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .vms-profile-avatar--sm {
        width: 2rem;
        height: 2rem;
      }

      .vms-profile-avatar--md {
        width: 2.75rem;
        height: 2.75rem;
      }

      .vms-profile-avatar--lg {
        width: 4.5rem;
        height: 4.5rem;
      }

      .vms-profile-avatar-initials {
        width: 100%;
        height: 100%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        background: var(--primary-color);
        color: var(--primary-contrast-color);
        font-weight: 700;
      }

      .vms-profile-avatar--sm .vms-profile-avatar-initials {
        font-size: 0.65rem;
      }

      .vms-profile-avatar--md .vms-profile-avatar-initials {
        font-size: 0.95rem;
      }

      .vms-profile-avatar--lg .vms-profile-avatar-initials {
        font-size: 1.2rem;
      }
    `
  ]
})
export class VmsProfileAvatarComponent {
  @Input() photoUrl?: string | null;
  @Input() gender?: number | null;
  @Input() name?: string | null;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  photoLoadFailed = false;

  get sizeClass(): string {
    return `vms-profile-avatar--${this.size}`;
  }

  get hasPhoto(): boolean {
    return !!this.photoUrl?.trim() && !this.photoLoadFailed;
  }

  get initials(): string {
    return getDisplayInitials(this.name);
  }

  onImageError(): void {
    this.photoLoadFailed = true;
  }
}
